import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../shared/table/table.component';
import { ItemModalComponent } from '../shared/item-modal/item-modal.component';
import Swal from 'sweetalert2';
import { catchError, forkJoin, of, switchMap } from 'rxjs';
import { CreateModalComponent } from '../shared/create-modal/create-modal.component';

// Definir interfaces para nuestros datos
interface UsuarioUpdate {
  nombres: string;
  apellidos: string;
  correo: string;
  clave?: string; // La propiedad clave es opcional
}
interface UsuarioCreate {
  nombres: string;
  apellidos: string;
  correo?: string;
  clave: string; // La propiedad clave es opcional
  codigo_documento: string;
  tipo_documento: string;
}

interface AsignacionUpdate {
  nivel_educativo: string;
  grado: number;
}

interface EstudianteCreate {
  nombres: string;
  apellidos: string;
  correo: string;
  clave: string; // Requerido para creación
  codigo_documento: string;
  tipo_documento: string;
  nivel_educativo: string;
  grado: number;
  cod_mod: string;
}

@Component({
  selector: 'app-estudiantes',
  standalone: true,
  imports: [
    FormsModule,
    TableComponent,
    ItemModalComponent,
    CreateModalComponent,
  ],
  templateUrl: './estudiantes.component.html',
  styleUrl: './estudiantes.component.css',
})
export class EstudiantesComponent implements OnInit {
  estudiantes: any[] = [];
  selectedItem: any = null;
  showModal: boolean = false;
  showCreateModal: boolean = false;
  claveOriginal: string = '';
  id_institucion: number = 0;
  studentData: EstudianteCreate = {
    nombres: '',
    apellidos: '',
    correo: '',
    clave: '',
    tipo_documento: '',
    codigo_documento: '',
    nivel_educativo: '',
    grado: 0,
    cod_mod: '',
  };
  fields: { key: string; label: string; type: string; options?: any }[] = [
    { key: 'nombres', label: 'Nombres', type: 'text' },
    { key: 'apellidos', label: 'Apellidos', type: 'text' },
    { key: 'correo', label: 'Correo', type: 'text' },
    {
      key: 'grado',
      label: 'Grado',
      type: 'select',
      options: [
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 },
        { value: 4, label: 4 },
        { value: 5, label: 5 },
        { value: 6, label: 6 },
      ],
    },
    {
      key: 'nivel_educativo',
      label: 'Nivel',
      type: 'select',
      options: [
        { value: 'PRIMARIA', label: 'Primaria' },
        { value: 'SECUNDARIA', label: 'Secundaria' },
      ],
    },
    { key: 'clave', label: 'Clave', type: 'text' },
  ];

  fieldsCreate: { key: string; label: string; type: string; options?: any }[] =
    [
      { key: 'nombres', label: 'Nombres', type: 'text' },
      { key: 'apellidos', label: 'Apellidos', type: 'text' },
      { key: 'correo', label: 'Correo', type: 'text' },
      {
        key: 'grado',
        label: 'Grado',
        type: 'select',
        options: [
          { value: 1, label: 1 },
          { value: 2, label: 2 },
          { value: 3, label: 3 },
          { value: 4, label: 4 },
          { value: 5, label: 5 },
          { value: 6, label: 6 },
        ],
      },
      {
        key: 'nivel_educativo',
        label: 'Nivel',
        type: 'select',
        options: [
          { value: 'PRIMARIA', label: 'Primaria' },
          { value: 'SECUNDARIA', label: 'Secundaria' },
        ],
      },
      { key: 'clave', label: 'Clave', type: 'text' },
      {
        key: 'tipo_documento',
        label: 'Tipo Documento',
        type: 'select',
        options: [
          { value: 'DNI', label: 'DNI' },
          { value: 'OTRO', label: 'Otro Documento' },
        ],
      },
      { key: 'codigo_documento', label: 'Codigo documento', type: 'text' },
      { key: 'cod_mod', label: 'Código(cod_mod)', type: 'text' },
    ];

  columns: { key: string; label: string }[] = [
    { key: 'codigo_documento', label: 'Código' },
    { key: 'nombres', label: 'Nombres' },
    { key: 'apellidos', label: 'Apellidos' },
    { key: 'nivel_educativo', label: 'Nivel Educativo' },
    { key: 'grado', label: 'Grado' },
    { key: 'institucion', label: 'Institucion' },
    { key: 'estado', label: 'Estado' },
  ];

  actions = [
    {
      class: 'bg-yellow-500 hover:bg-yellow-600 text-white py-1 px-3 rounded',
      icon: 'fas fa-edit',
      tooltip: 'Editar',
      callback: (item: any) => this.openModal(item),
    },
    {
      class: 'bg-red-500 hover:bg-red-600 text-white py-1 px-3 rounded',
      icon: 'fas fa-trash-alt',
      tooltip: 'Eliminar',
      callback: (item: any) => this.eliminarItem(item),
      disabled: (item: any) => item.estado === 0,
    },
  ];

  constructor(private http: HttpClient, private router: Router) {}

  ngOnInit() {
    this.obtenerEstudiantes();
  }

  obtenerEstudiantes() {
    this.http
      .get<any[]>(`${environment.apiUrl}/rol-usuario?id_rol=4`)
      .subscribe(
        (response) => {
          this.estudiantes = response.map((item) => ({
            id_usuario: item.usuario.id_usuario,
            codigo_documento: item.usuario.codigo_documento,
            nombres: item.usuario.nombres,
            apellidos: item.usuario.apellidos,
            correo: item.usuario.correo,
            nivel_educativo:
              item.asignacion?.nivel_educativo || 'No especificado',
            grado: item.asignacion?.grado || 'No especificado',
            institucion:
              item.institucionEducativa?.cen_edu || 'No especificado',
            estado: item.estado,
            clave: '',
            asignacion: item.asignacion,
            id_rol_usuario: item.id_rol_usuario,
          }));
        },
        (error) => {
          console.error('Error al obtener los estudiantes:', error);
        }
      );
  }

  volver(): void {
    this.router.navigate(['/main']);
  }

  openModal(item?: any) {
    this.selectedItem = item;
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
    this.selectedItem = null;
  }

  openCreateModal() {
    this.showCreateModal = true;
  }

  closeCreateModal() {
    this.showCreateModal = false;
    this.studentData = {
      nombres: '',
      apellidos: '',
      correo: '',
      clave: '',
      tipo_documento: '',
      codigo_documento: '',
      nivel_educativo: '',
      grado: 0,
      cod_mod: '',
    };
  }

  saveChanges(updatedItem: any) {
    this.updateStudent(updatedItem);
  }

  createStudent(studentData: EstudianteCreate) {
    Swal.fire({
      title: 'Crear Estudiante',
      text: '¿Estás seguro de crear el nuevo estudiante?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Crear',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        let usuarioData: UsuarioCreate = {
          tipo_documento: studentData.tipo_documento,
          codigo_documento: studentData.codigo_documento,
          nombres: studentData.nombres,
          apellidos: studentData.apellidos,
          clave: studentData.clave,
        };

        if (studentData.correo != '') {
          usuarioData.correo = studentData.correo;
        }
        //console.log(studentData.correo);
        // Primer POST: Crear usuario
        // Consulta GET para obtener id_institucion basado en cod_mod
        this.http
          .get<any>(
            `${environment.apiUrl}/institucion-educativa/institucion/${studentData.cod_mod}`
          )
          .subscribe({
            next: (response) => {
              //console.log(response);
              this.id_institucion = response.id_institucion_educativa;
              //console.log(this.id_institucion);

              this.http
                .post<any>(environment.apiUrl + '/usuario', usuarioData)
                .pipe(
                  switchMap((usuarioResponse: any) => {
                    const id_usuario = usuarioResponse.id_usuario;
                    //TODO
                    // Segundo POST: Crear rol_usuario
                    const rolUsuarioData = {
                      id_usuario: id_usuario,
                      id_rol: 4, // Rol de estudiante
                      id_institucion_educativa: this.id_institucion,
                    };
                    return this.http.post<any>(
                      environment.apiUrl + '/rol-usuario',
                      rolUsuarioData
                    );
                  }),
                  switchMap((rolUsuarioResponse: any) => {
                    const id_rol_usuario = rolUsuarioResponse.id_rol_usuario;

                    // Tercer POST: Crear asignación
                    const asignacionData = {
                      id_rol_usuario: id_rol_usuario,
                      nivel_educativo: studentData.nivel_educativo,
                      grado: studentData.grado,
                    };
                    return this.http.post<any>(
                      environment.apiUrl + '/asignacion',
                      asignacionData
                    );
                  }),
                  catchError((error) => {
                    console.error('Error al crear el estudiante:', error);
                    Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text:
                        error.error.message || 'Error al crear el estudiante',
                    });
                    return of(null); // Retorna un observable nulo para manejar el error
                  })
                )
                .subscribe((response) => {
                  if (response) {
                    Swal.fire(
                      'Éxito',
                      'Estudiante creado correctamente.',
                      'success'
                    ).then(() => {
                      this.closeCreateModal();
                      this.obtenerEstudiantes(); // Actualizar la lista de estudiantes
                    });
                  }
                });
            },
            error: (error) => {
              //console.error('Error al obtener la institucion:', error);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.error.message || 'Error al obtener la institucion',
              });
            },
          });
      }
    });
  }

  updateStudent(updatedItem: any) {
    Swal.fire({
      title: 'Actualizar Estudiante',
      text: '¿Estás seguro de actualizar el estudiante?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Actualizar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const usuarioData: UsuarioUpdate = {
          nombres: updatedItem.nombres,
          apellidos: updatedItem.apellidos,
          correo: updatedItem.correo,
        };

        if (updatedItem.clave && updatedItem.clave !== this.claveOriginal) {
          usuarioData.clave = updatedItem.clave;
        }

        const asignacionData: AsignacionUpdate = {
          nivel_educativo: updatedItem.nivel_educativo,
          grado: updatedItem.grado,
        };

        forkJoin({
          usuario: this.http.patch(
            environment.apiUrl + `/usuario/${updatedItem.id_usuario}`,
            usuarioData
          ),
          asignacion: this.http.patch(
            environment.apiUrl +
              `/asignacion/${updatedItem.asignacion.id_asignacion}`,
            asignacionData
          ),
        })
          .pipe(
            catchError((error) => {
              console.error('Error al guardar los cambios:', error);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.error.message || 'Error al guardar los cambios',
              });
              return of([null]);
            })
          )
          .subscribe((response) => {
            if (response) {
              Swal.fire(
                'Éxito',
                'Estudiante actualizado correctamente.',
                'success'
              ).then(() => {
                this.closeModal();
                this.obtenerEstudiantes();
              });
            }
          });
      }
    });
  }

  eliminarItem(item: any) {
    Swal.fire({
      title: 'Eliminar Estudiante',
      text: '¿Estas seguro de eliminar la estudiante?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.http
          .delete(`${environment.apiUrl}/rol-usuario/${item.id_rol_usuario}`)
          .subscribe(
            () => {
              Swal.fire(
                'Eliminado',
                'El/la estudiante ha sido eliminado(a).',
                'success'
              );
              this.obtenerEstudiantes(); // Refresca la lista
            },
            (error) => {
              Swal.fire({
                title: 'Error',
                text:
                  error.error.message || 'No se pudo eliminar al estudiante.',
                icon: 'error',
              });
            }
          );
      }
    });
  }

  goToCreateEstudiantes(): void {
    this.router.navigate(['/create-estudiantes']);
  }
}
